import { pipe } from 'fp-ts/function';
import isEmpty from 'lodash/isEmpty';

import { api, ApiMethod, ApiRequest } from 'services/api';

export function combineConfig(
  initialConfig: ApiRequest,
  lazyConfig?: Partial<ApiRequest>,
): ApiRequest {
  return {
    method: ApiMethod.post,
    ...initialConfig,
    ...(lazyConfig ?? {}),
  };
}

export function formatRequestVariables<Body extends Record<string, unknown>>(
  requestConfig: Partial<ApiRequest>,
  variables?: Body,
): ApiRequest {
  const vars = isEmpty(variables) ? {} : variables;
  const requestVars = requestConfig.method === ApiMethod.delete ? { params: vars } : { data: vars };
  return {
    ...requestConfig,
    ...requestVars,
  };
}

export function createConfiguredRequest<Response>(config: ApiRequest): Promise<Response> {
  if (!('url' in config) || !config.method) {
    return Promise.reject(new Error('Missing request configuration'));
  }

  return api.request<Response>(config).then(({ data }) => data);
}

export type LazyRestRequestConfig<Body extends Record<string, unknown>> = {
  requestData?: Body;
  requestConfig?: Partial<ApiRequest>;
};

export function createLazyRestRequest<Body extends Record<string, unknown>, Response = any>(
  initialConfig: Partial<ApiRequest>,
) {
  return (lazyRestConfig?: LazyRestRequestConfig<Body>) =>
    pipe(
      formatRequestVariables(
        combineConfig(initialConfig, lazyRestConfig?.requestConfig),
        lazyRestConfig?.requestData,
      ),
      (config: ApiRequest) => createConfiguredRequest<Response>(config),
    );
}
